import React from 'react';
import { formatStatus, getStatusColor } from '../../utils/redemptionHelpers';

const RedemptionStatusBadge = ({ status }) => {
  return (
    <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(status)}`}>
      {formatStatus(status)}
    </span>
  );
};

export default RedemptionStatusBadge;

